/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return; // Ensure the existence of the section header
        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        const section = this.closest('.collection-tabs');
        this.themeScroll = section ? section.querySelector('theme-scroll') : null;
        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return; // Ensure the existence of the slider
      const products = slider.querySelectorAll(`.collection-tabs--product:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);

      products.forEach((product) => product.classList.remove('carousel__slide'));
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      this.themeScroll.init();
      this.themeScroll.querySelector('.theme-scroll--inner').scroll({
        top: 0,
        left: 0
      });
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}

/**
 * Banner Slider Animation Controller
 * Triggers slide hint animation when banner enters viewport center
 */
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing banner animation');
  
  // Find all banner sliders on the page
  const bannerSliders = document.querySelectorAll('.collection-banner-slider');
  console.log('Found banner sliders:', bannerSliders.length);
  
  bannerSliders.forEach((slider, index) => {
    const track = slider.querySelector('.collection-banner-slider__track');
    
    if (!track) {
      console.log('No track found for slider', index);
      return;
    }
    
    console.log('Initializing slider', index);
    let animationTriggered = false;
    
    // Create observer with multiple thresholds for better detection
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log('Intersection observed:', {
          isIntersecting: entry.isIntersecting,
          ratio: entry.intersectionRatio,
          triggered: animationTriggered
        });
        
        if (entry.isIntersecting && !animationTriggered && entry.intersectionRatio >= 0.1) {
          console.log('✓ Triggering animation for slider', index);
          
          // Add animation class to track
          track.classList.add('slide-hint-active');
          console.log('Added slide-hint-active class');
          
          animationTriggered = true;
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Start observing
    observer.observe(slider);
    console.log('Started observing slider', index);
    
    // Fallback: If banner is already visible on page load
    setTimeout(() => {
      if (!animationTriggered) {
        const rect = slider.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        console.log('Fallback check:', { isVisible, top: rect.top, bottom: rect.bottom });
        
        if (isVisible) {
          console.log('✓ Banner already visible, triggering animation via fallback');
          track.classList.add('slide-hint-active');
          animationTriggered = true;
          
          setTimeout(() => {
            track.classList.remove('slide-hint-active');
          }, 5000);
        }
      }
    }, 1000);
  });
});